import * as actions from './actions';

export default {
  settings: actions.getSettings,
  roundId: actions.getRoundId,
  card_history: actions.getCoefsHistory,
  get_top_wins: actions.getTopWins,
  game_state: actions.getInfo,
  cashed_out: actions.getCashedOut,
};